import { Col, Form, Input, Row } from 'antd'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import useFetchSelect from '../../../../../elements/Hooks/useFetchSelect'
import FormSectionTitle from '../../../../../elements/FormSectionTitle'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import InfoText from '../../../../../elements/InfoText'
import { get, groupBy, isEmpty } from 'lodash'
import { defaultFormItemLayout } from '../../../../../modules/FormItems'
import { strVal } from '../../../../../modules/Utils'
import React, { useState, useEffect } from 'react'
import { compose } from 'recompose'
import CountrySelect from '../../../../../elements/Select/Country'

function Communication(props) {
  const { getFieldDecorator, setFieldsValue, getFieldValue } = props.form
  const { contract, type, member } = props

  console.log(33, { member })

  const [billRep, setBillRep] = useState({})
  const [clientRep, setClientRep] = useState({})
  const [companyRep, setCompanyRep] = useState({})

  useEffect(() => {
    console.log(billRep, clientRep, companyRep)
    if (!!billRep) {
      setFieldsValue({
        'supplierRep.phone.label': billRep.phone || billRep.mobile,
        'supplierRep.email.label': billRep.email,
        'supplierRep.address.label': strVal(billRep, 'member.address.label'),
      })
    }
    if (!!clientRep) {
      setFieldsValue({
        'payableRep.phone.label': clientRep.phone || clientRep.mobile,
        'payableRep.email.label': clientRep.email,
        'payableRep.address.label': strVal(clientRep, 'member.address.label'),
      })
    }
    if (!!companyRep) {
      setFieldsValue({
        'companyRep.phone.label': companyRep.phone || companyRep.mobile,
        'companyRep.email.label': companyRep.email,
        'companyRep.address.label': strVal(companyRep, 'member.address.label'),
      })
    }
  }, [billRep, clientRep, companyRep])

  const company = get(props, 'contract.company._id', '')

  const { SelectData: CompanyRepSelect } = useFetchSelect({
    url: `members/${company.replace('members/', '')}/representatives`,
    dependencyArray: [company],
    dontFetch: isEmpty(company),
  })

  const { SelectData: CompanyEmailSelect } = useFetchSelect({
    url: `contacts/email/${(getFieldValue('companyRep._id') || '').replace('members/', '')}`,
    dependencyArray: [getFieldValue('companyRep._id')],
    dontFetch: isEmpty(getFieldValue('companyRep._id')),
  })

  const supplier = get(props, 'supplier.owner')

  const { SelectData: SupplierRepSelect } = useFetchSelect({
    url: `members/${supplier.replace('members/', '')}/representatives`,
    dependencyArray: [supplier],
    dontFetch: isEmpty(supplier),
    dataFunction: (list) =>
      Object.values(groupBy(list, '_id')).map((i) => ({
        ...i[0],
        position: i.map((j) => j.position).join(', '),
      })),
  })

  const { SelectData: SupplierEmailSelect } = useFetchSelect({
    url: `contacts/email/${(getFieldValue('supplierRep._id') || '').replace('members/', '')}`,
    dependencyArray: [getFieldValue('supplierRep._id')],
    dontFetch: isEmpty(getFieldValue('supplierRep._id')),
  })

  const { SelectData: PayableEmailSelect } = useFetchSelect({
    url: `contacts/email/${(getFieldValue('payableRep._id') || '').replace('members/', '')}`,
    dependencyArray: [getFieldValue('payableRep._id')],
    dontFetch: isEmpty(getFieldValue('payableRep._id')),
  })

  return (
    <Form layout="horizontal">
      <FormSectionTitle title={'NOTICE ADDRESS'} />
      <Row>
        <Col span={12}>
          <Form.Item label="Country" {...defaultFormItemLayout}>
            {getFieldDecorator('supplier.address.country', {
              initialValue: get(contract, 'supplier.address.country') || get(member, 'address.country'),
              rules: [
                {
                  required: true,
                  message: "Country can't be empty ",
                },
              ],
            })(<CountrySelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Postcode" {...defaultFormItemLayout}>
            {getFieldDecorator('supplier.address.postcode', {
              initialValue: get(contract, 'supplier.address.postcode') || get(member, 'address.postcode'),
            })(<Input placeholder="Postcode" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Street" {...defaultFormItemLayout}>
            {getFieldDecorator('supplier.address.street', {
              initialValue: get(contract, 'supplier.address.street') || get(member, 'address.street'),
              rules: [
                {
                  required: true,
                  message: "Street can't be empty ",
                },
              ],
            })(<Input placeholder="Street" style={{ width: '250%' }} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Building" {...defaultFormItemLayout}>
            {getFieldDecorator('supplier.address.address', {
              initialValue: get(contract, 'supplier.address.address') || get(member, 'address.address'),
            })(<Input placeholder="Building" style={{ width: '250%' }} />)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item label="Town / Suburb" {...defaultFormItemLayout}>
            {getFieldDecorator('supplier.address.city', {
              initialValue: get(contract, 'supplier.address.city') || get(member, 'address.city'),
            })(<Input placeholder="Town / Suburb" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="City / State" {...defaultFormItemLayout}>
            {getFieldDecorator('supplier.address.state', {
              initialValue: get(contract, 'supplier.address.state') || get(member, 'address.state'),
              rules: [
                {
                  required: true,
                  message: '"City / State can\'t be empty ',
                },
              ],
            })(<Input placeholder="City / State" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Label" {...defaultFormItemLayout}>
            {getFieldDecorator('supplier.address.label', {
              initialValue: get(contract, 'supplier.address.label') || get(member, 'address.label'),
            })(<Input placeholder="Label" style={{ width: '250%' }} />)}
          </Form.Item>
        </Col>
      </Row>

      <FormSectionTitle title={'VENDOR CONTRACT REPRESENTATIVE'} />
      <Row>
        <Col span={12}>
          <Form.Item label="Representative" {...defaultFormItemLayout}>
            {getFieldDecorator('supplierRep._id', {
              initialValue: get(contract, 'supplierRep._id') || get(member, 'supplierRep._id'),
              rules: [
                {
                  required: true,
                  message: "Representative can't be empty ",
                },
              ],
            })(
              <SupplierRepSelect
                style={{ width: '100%' }}
                keyAtr={'owner'}
                valueAtr={'name'}
                setSelected={setBillRep}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Phone" {...defaultFormItemLayout}>
            {getFieldDecorator('supplierRep.phone.label', {
              initialValue: get(contract, 'supplierRep.phone.label') || get(member, 'supplierRep.phone.label'),
              rules: [
                {
                  required: true,
                  message: "Phone can't be empty ",
                },
              ],
            })(<Input placeholder="Phone" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Email" {...defaultFormItemLayout}>
            {getFieldDecorator('supplierRep.email.label', {
              initialValue: get(contract, 'supplierRep.email.label') || get(member, 'supplierRep.email.label'),
              rules: [
                {
                  required: true,
                  message: "Email can't be empty ",
                },
              ],
            })(<SupplierEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Address" {...defaultFormItemLayout}>
            {getFieldDecorator('supplierRep.address.label', {
              initialValue: get(contract, 'supplierRep.address.label') || get(member, 'supplierRep.address.label'),
            })(<Input placeholder="Address" />)}
          </Form.Item>
        </Col>
      </Row>
      <FormSectionTitle title={'VENDOR BILLING REPRESENTATIVE'} />
      <Row>
        <Col span={12}>
          <Form.Item label="Billing Representative" {...defaultFormItemLayout}>
            {getFieldDecorator('payableRep._id', {
              initialValue: get(contract, 'payableRep._id') || get(member, 'payableRep._id'),
              rules: [
                {
                  required: true,
                  message: " Billing Representative can't be empty ",
                },
              ],
            })(
              <SupplierRepSelect
                style={{ width: '100%' }}
                keyAtr={'owner'}
                valueAtr={'name'}
                setSelected={setClientRep}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Phone" {...defaultFormItemLayout}>
            {getFieldDecorator('payableRep.phone.label', {
              initialValue: get(contract, 'payableRep.phone.label') || get(member, 'payableRep.phone.label'),
              rules: [
                {
                  required: true,
                  message: "Phone can't be empty ",
                },
              ],
            })(<Input placeholder="Phone" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Email" {...defaultFormItemLayout}>
            {getFieldDecorator('payableRep.email.label', {
              initialValue: get(contract, 'payableRep.email.label') || get(member, 'payableRep.email.label'),
              rules: [
                {
                  required: true,
                  message: "Email can't be empty ",
                },
              ],
            })(<PayableEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Address" {...defaultFormItemLayout}>
            {getFieldDecorator('payableRep.address.label', {
              initialValue: get(contract, 'payableRep.address.label') || get(member, 'payableRep.address.label'),
            })(<Input placeholder="Address" />)}
          </Form.Item>
        </Col>
      </Row>
      <FormSectionTitle title={'COMPANY CONTRACT REPRESENTATIVE'} />
      <Row>
        <Col span={12}>
          <Form.Item label="Representative" {...defaultFormItemLayout}>
            {getFieldDecorator('companyRep._id', {
              initialValue: get(contract, 'companyRep._id') || get(member, 'companyRep._id'),
              rules: [{ required: true, message: 'Please Select a Representative!' }],
            })(
              <CompanyRepSelect
                keyAtr={'owner'}
                valueAtr={'name'}
                style={{ width: '100%' }}
                setSelected={setCompanyRep}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Phone" {...defaultFormItemLayout}>
            {getFieldDecorator('companyRep.phone.label', {
              initialValue: get(contract, 'companyRep.phone.label') || get(member, 'companyRep.phone.label'),
              rules: [
                {
                  required: true,
                  message: "Phone can't be empty ",
                },
              ],
            })(<Input placeholder="Phone" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Email" {...defaultFormItemLayout}>
            {getFieldDecorator('companyRep.email.label', {
              initialValue: get(contract, 'companyRep.email.label') || get(member, 'companyRep.email.label'),
              rules: [
                {
                  required: true,
                  message: "Email can't be empty ",
                },
              ],
            })(<CompanyEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
          </Form.Item>
        </Col>
      </Row>
      {type !== 'update' && <InfoText text={'Contact details are pre-loaded from supplier default contacts'} />}
    </Form>
  )
}

export default compose(Form.create(), withLoadingSection)(Communication)
